import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, Row } from 'reactstrap';
import { AddUserButton, FilterButton, SearchInput, UserCard, CommonButton, UserInput, SingleSelect, MultiSelectOpt, ErrorBlock } from '../../../Components/CommonComponents';
import excelImg from '../../../images/excel.png'
import closeImg from '../../../images/modalclose.png'
import './index.css'
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { messages } from '../../../utils/constant-messages';
import { addUser, getBusinessHeadList, getListUser, getNationalHeadList, getStateHeadList, getStateHeadTMById, updateActiveInactiveUser, updateUser } from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import Pagination from '../../../Components/Pagination/Pagination'
import lodash from 'lodash';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import Storage from '../../../services/Storage';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const roleOptions = [
  { value: Roles.TM_ID, label: 'TM' },
  { value: Roles.SH_ID, label: 'SH' },
  { value: Roles.NH_ID, label: 'NH' },
  { value: Roles.BH_ID, label: 'BH' },
];

const designationOpt = [
  { value: 'Territory Manager', label: 'Territory Manager', role: Roles.TM_ID },
  { value: 'Sales Executive', label: 'Sales Executive', role: Roles.TM_ID },
  { value: 'State Head', label: 'State Head', role: Roles.SH_ID },
  { value: 'National Head', label: 'National Head', role: Roles.NH_ID },
  { value: 'Business Head', label: 'Business Head', role: Roles.BH_ID }
]

const userStatusOpt = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
]

const ManageUser = () => {
  let userInfo = Storage.getUserInfoDetail();
  let loginId = userInfo ? userInfo.id : null;

  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_MANAGE_USER)) {
      navigate('/');
    }
  }, [...localPermission])


  let pageNo = useMemo(() => Storage.getManageUserPage(), [Storage.getManageUserPage()]);

  const initialValues = { userName: '', userRole: '', userDesignation: '', userMobile: '', userEmail: '', tmManagerRole: '', userManagerSh: '', userManagerNh: '', userManagerBh: '' }

  const [roleId, setRoleId] = useState('');

  const [statusVal, setStatusval] = useState('');
  const [statusId, setStatusId] = useState('');

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  const [searchQuery, setSearchQuery] = useState('');
  const [userQuery, setUserQuery] = useState('');

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [userData, setUserData] = useState([])
  const [show, setShow] = useState(null)
  const [filterbtnActive, setFilterBtnActive] = useState(false)
  const [roleVal, setRoleVal] = useState('')

  const [shList, setShList] = useState([]);
  const [nhList, setNhList] = useState([]);
  const [bhList, setBhList] = useState([]);
  const [territoryList, setTerritoryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [allData, setAllData] = useState([])

  // Filter Modal
  const [showFilterModal, setShowFilterModal] = useState(false)

  // User Modal
  const [userModal, setUserModal] = useState(false)
  const [userDetail, setUserDetail] = useState(initialValues)

  const [editId, setEditId] = useState('')

  // Multi Select
  const [selectedTerritory, setSelectedTerritory] = useState([]);
  const [selectedState, setSelectedState] = useState([]);

  const [errorMsg, setErrorMsg] = useState({ territoryError: '', stateErr: '' })

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  useEffect(() => {
    setIsloading(true);
    getUserList();
  }, [searchQuery, page, pageSize, roleId, statusId])


  const getUserList = () => {
    let tempStatusVal = '';
    if (statusId === 'Active') {
      tempStatusVal = true
    } else if (statusId === 'Inactive') {
      tempStatusVal = false
    }

    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: pageSize || 10,
      role_id: roleId || '',
      is_active: tempStatusVal,
      is_export: false,
    }
    getListUser((res) => {
      const { data, success, error } = res;
      if (success === true) {
        if (data && data.users) {
          setUserData(data.users);
        } else {
          setUserData([]);
        }
        let count = Number(data.total_records);
        setCount(count);
        let totalPages = Math.ceil(count / pageSize);
        setTotalPages(totalPages);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const getSHList = () => {
    let payload = {
      id: '', // loginId not passed to get all
    }
    getStateHeadList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        let filterSh = data && data.length > 0 ? data.filter(e => e.role === Roles.SH_NAME) : [];
        setShList(filterSh);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const getNHList = () => {
    let payload = {
      id: '', // loginId not passed to get all
    }
    getNationalHeadList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setNhList(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const getBHList = () => {
    getBusinessHeadList((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setBhList(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    });
  }

  const getStateHeadTM = () => {
    let payload = {
      id: loginId,
    }
    getStateHeadTMById((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setAllData(data);

        // change key in array
        const newTerritoryArr = data && data.length > 0 && data[0].territory && data[0].territory.length > 0 ? data[0].territory.map(function (obj) {
          obj['label'] = obj['name']; // Assign new key new = old
          obj['value'] = obj['territory_id']; // Assign new key
          delete obj['name']; // Delete old key
          delete obj['territory_id'];
          return obj;
        }) : '';
        if (newTerritoryArr && newTerritoryArr.length > 0) {
          setTerritoryList(newTerritoryArr);
        } else {
          setTerritoryList([]);
          setSelectedTerritory([]);
        }

        // change key in array
        const newStateArr = data && data.length > 0 && data[0].state && data[0].state.length > 0 ? data[0].state.map(function (obj) {
          obj['label'] = obj['name']; // Assign new key new = old
          obj['value'] = obj['state_id']; // Assign new key
          delete obj['name']; // Delete old key
          delete obj['state_id'];
          return obj;
        }) : '';

        if (newStateArr && newStateArr.length > 0) {
          setStateList(newStateArr);
        } else {
          setStateList([]);
          setSelectedState([]);
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  }

  const handleSearchChange = (e) => {
    let q = e.target.value;
    delayedQuery(q);
    setUserQuery(q);
    if (q) {
      setPage(1);
    } else {
      setPage(Number(pageNo));
    }
  };

  const handleCardClick = (id) => {
    if (id === show) {
      setShow(null)
    } else {
      setShow(id)
    }
  }

  const handleFilterBtnClick = () => {
    setShowFilterModal(!showFilterModal)
    // setRoleVal('')
  }

  const handleChangeRole = (e) => {
    setRoleVal(e.target.value);
  }
  const handleChangeUserStatus = (e) => {
    setStatusval(e.target.value);
  }

  const handleResetFilter = () => {
    setRoleVal('');
    setRoleId('');
    setStatusval('');
    setStatusId('')
    setShowFilterModal(false)
    setFilterBtnActive(false)
    setPage(1);
    Storage.setManageUserPage(1);
  }

  const handleApplyFilter = (e) => {
    e.preventDefault();
    setRoleId(roleVal);
    setStatusId(statusVal);
    setShowFilterModal(false)
    setFilterBtnActive(true)
    setPage(1);
    Storage.setManageUserPage(1);
  }

  const handleAddUser = () => {
    setEditId('')
    setUserDetail('');
    setSelectedTerritory([])
    setSelectedState([])

    getSHList();
    getNHList();
    getBHList();
    getStateHeadTM();

    setUserModal(!userModal)
    setPage(1);
    Storage.setManageUserPage(1);
  }

  const handleChangeUser = (e, key) => {
    const { name, value } = e.target;
    setUserDetail({ ...userDetail, [name]: value });
    setPage(1);
    Storage.setManageUserPage(1);
    if (key === "userRole") {
      setSelectedTerritory([])
      setSelectedState([])
      let roleValue = e.target.value;
      if (roleValue) {
        let filterDesignation = designationOpt && designationOpt.length > 0 ? designationOpt.filter(w => w.role === +roleValue) : [];
        setUserDetail({ ...userDetail, userRole: roleValue, userDesignation: filterDesignation && filterDesignation.length > 0 ? filterDesignation[0].value : '', tmManagerRole: +roleValue === Roles.TM_ID ? Roles.SH_ID : '', userManagerSh: '', userManagerNh: '', userManagerBh: '' })
      } else {
        setUserDetail({ ...userDetail, userRole: roleValue, userDesignation: '', tmManagerRole: +roleValue === Roles.TM_ID ? Roles.SH_ID : '', userManagerSh: '', userManagerNh: '', userManagerBh: '' })
      }

      // add all Territory and state
      // change key in array
      const newTerritoryArr = allData && allData.length > 0 && allData[0].territory && allData[0].territory.length > 0 ? allData[0].territory : '';
      if (newTerritoryArr && newTerritoryArr.length > 0) {
        const newTerritoryArr1 = newTerritoryArr.map(function (obj) {
          delete obj['state_id'];
          return obj;
        });
        setTerritoryList(newTerritoryArr1);
      } else {
        setTerritoryList([]);
        setSelectedTerritory([]);
      }

      // change key in array
      const newStateArr = allData && allData.length > 0 && allData[0].state && allData[0].state.length > 0 ? allData[0].state : '';

      if (newStateArr && newStateArr.length > 0) {
        const newStateArr1 = newStateArr.map(function (obj) {
          delete obj['territory_id'];
          return obj;
        });
        setStateList(newStateArr1);
      } else {
        setStateList([]);
        setSelectedState([]);
      }
    }

    if (key === "userManagerSh") {
      // setSelectedTerritory([]);
    }

    if (key === 'userManagerNh' || key === 'userManagerBh') {
      setSelectedState([]);
    }
  }

  const handleChangeTerritory = (data) => {
    setPage(1);
    Storage.setManageUserPage(1);
    if (data) {
      setErrorMsg({ ...errorMsg, territoryError: '' })
      setSelectedTerritory(data)
    }
  }

  const handleChangeState = (data) => {
    setPage(1);
    Storage.setManageUserPage(1);
    if (data) {
      setErrorMsg({ ...errorMsg, stateErr: '' })
      setSelectedState(data)
    }
  }

  const handleUserSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    Storage.setManageUserPage(1);
    if ((+userDetail.userRole === Roles.TM_ID && selectedTerritory.length === 0)) {
      setErrorMsg({ ...errorMsg, territoryError: 'please select Territory' })
    } else if (((+userDetail.userRole === Roles.SH_ID || +userDetail.userRole === Roles.NH_ID) && selectedState.length === 0)) {
      setErrorMsg({ ...errorMsg, stateErr: 'please select State' })
    } else {
      setErrorMsg('')
      setUserModal(false);

      let payload = {
        name: userDetail.userName || '',
        role_id: userDetail.userRole ? Number(userDetail.userRole) : '',
        designation: userDetail.userDesignation || '',
        manager_id: userDetail.userManagerSh ? Number(userDetail.userManagerSh) : '' ||
          userDetail.userManagerNh ? Number(userDetail.userManagerNh) : '' ||
            userDetail.userManagerBh ? Number(userDetail.userManagerBh) : '',
        email: userDetail.userEmail || '',
        mobile: userDetail.userMobile || '',
        territories: selectedTerritory || [],
        states: selectedState || [],
      }

      let editPayload = {
        id: editId,
        name: userDetail.userName || '',
        role_id: userDetail.userRole ? Number(userDetail.userRole) : '',
        designation: userDetail.userDesignation || '',
        manager_id: userDetail.userManagerSh ? Number(userDetail.userManagerSh) : '' ||
          userDetail.userManagerNh ? Number(userDetail.userManagerNh) : '' ||
            userDetail.userManagerBh ? Number(userDetail.userManagerBh) : '',
        email: userDetail.userEmail || '',
        mobile: userDetail.userMobile || '',
        territories: selectedTerritory || [],
        states: selectedState || [],
      }
      if (!editId) {
        setIsloading(false);
        setIsModalLoading(true);
        addUser((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setIsloading(false);
            setIsModalLoading(false);
            getUserList();
          } else if (success === false || success === 'undefined') {
            getUserList();
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          }
          setIsloading(false);
          setIsModalLoading(false);
        }, payload);
      }

      if (editId) {
        setIsloading(false);
        setIsModalLoading(true);
        updateUser((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setIsloading(false);
            setIsModalLoading(false);
            getUserList();
          } else if (success === false || success === 'undefined') {
            getUserList();
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          }
          setIsloading(false);
          setIsModalLoading(false);
        }, editPayload);
      }
    }
  }

  const handleEditUserClick = (e, elem) => {
    e.preventDefault();
    setEditId(elem.id)
    getStateHeadTM();

    setUserDetail({ ...userDetail, userName: elem.name, userRole: elem.role_id, userDesignation: elem.designation, userMobile: elem.mobile, userEmail: elem.email });
    setErrorMsg({ territoryError: '', stateErr: '' })
    
    if (elem.role_id === Roles.TM_ID) {
      getSHList();
      getNHList();
      setUserDetail({ ...userDetail, userName: elem.name, userRole: elem.role_id, userDesignation: elem.designation, userMobile: elem.mobile, userEmail: elem.email, tmManagerRole: elem.manager_role === Roles.NH_NAME ? Roles.NH_ID : Roles.SH_ID, userManagerSh: elem.manager_id, userManagerNh: '', userManagerBh: '' });
    } else if (elem.role_id === Roles.SH_ID) {
      getNHList();

      setUserDetail({ ...userDetail, userName: elem.name, userRole: elem.role_id, userDesignation: elem.designation, userMobile: elem.mobile, userEmail: elem.email, tmManagerRole: '', userManagerSh: '', userManagerNh: elem.manager_id, userManagerBh: '' });
    } else if (elem.role_id === Roles.NH_ID) {
      getBHList();
      setUserDetail({ ...userDetail, userName: elem.name, userRole: elem.role_id, userDesignation: elem.designation, userMobile: elem.mobile, userEmail: elem.email, tmManagerRole: '', userManagerSh: '', userManagerNh: '', userManagerBh: elem.manager_id });
    } else if (elem.role_id === Roles.BH_ID) {
      setUserDetail({ ...userDetail, userName: elem.name, userRole: elem.role_id, userDesignation: elem.designation, userMobile: elem.mobile, userEmail: elem.email, tmManagerRole: '', userManagerSh: '', userManagerNh: '', userManagerBh: '' });
    }

    if (elem.territories && elem.territories.length > 0) {
      const territoryValArr = elem.territories.map(function (obj) {
        delete obj['date'];
        return obj;
      });
      setSelectedTerritory(territoryValArr);
    } else {
      setSelectedTerritory([])
    }

    if (elem.states && elem.states.length > 0) {
      const stateValArr = elem.states.map(function (obj) {
        delete obj['date'];
        return obj;
      });
      setSelectedState(stateValArr)
    } else{
      setSelectedState([])
    }

    setUserModal(true)
  }

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setManageUserPage(Number(page));
      // getUserList(page, pageSize);
    },
    [page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      // getUserList(page, pageSize);
    },
    [page, pageSize]
  );

  // Excel sheet
  const handleExcelSheet = (page, pageSize) => {
    let tempStatusVal = '';
    if (statusId === 'Active') {
      tempStatusVal = true
    } else if (statusId === 'Inactive') {
      tempStatusVal = false
    }

    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: 100000,
      role_id: roleId || '',
      is_active: tempStatusVal,
      is_export: true,
    }
    getListUser((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handleChangeUserSwitch = (e, item) => {
    if (item.id) {
      let index = userData.findIndex((e) => e.id === item.id);
      userData[index].is_active = e;
      setUserData([...userData]);
    }

    let payload = {
      user_id: item.id,
      is_active: e,
    }
    setIsloading(true);
    if (e === true) {
      updateActiveInactiveUser((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          getUserList();
        } else if (success === false || success === 'undefined') {
          getUserList();
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    }
    if (e === false) {
      swal({
        title: 'Inactive User',
        text: 'User will not able to access mobile and web app. Are you sure want to InActive this user?',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      }).then((isConfirm) => {
        if (isConfirm) {
          setIsloading(true);
          if (item.id) {
            let index = userData.findIndex((e) => e.id === item.id);
            userData[index].is_active = false;
            setUserData([...userData]);
          }

          updateActiveInactiveUser((res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setIsloading(false);
              getUserList();
            } else if (success === false || success === 'undefined') {
              getUserList();
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
            setIsloading(false);
          }, payload);
        } else {
          setIsloading(false)
          if (item.id) {
            let index = userData.findIndex((e) => e.id === item.id);
            userData[index].is_active = true;
            setUserData([...userData]);
          }
        }
      });
    }
  }

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='manageUser'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Manage User' className="lightTitle" />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className='searchArea'>
                        <div className='searchBlock'>
                          <SearchInput
                            // parentStyle={{maxWidth: '200px'}} 
                            InputProps={{
                              name: 'search',
                              placeholder: 'Search by Name, Mobile or Email'
                            }}
                            onChange={handleSearchChange}
                            value={userQuery}
                          />
                          <FilterButton onClick={handleFilterBtnClick} className={filterbtnActive ? 'activeFilterBtn' : 'inActiveFilterBtn'} />
                        </div>
                        <img src={excelImg} alt="excel" width={35} height={35} className="excelIcon mr-4" onClick={() => handleExcelSheet()} />
                        <AddUserButton customClass="p-0" onClick={handleAddUser} />
                      </div>
                    </Col>
                  </Row>

                  {/* card Block */}
                  {userData && userData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        {userData.map((elem, index) => {
                          return (
                            <UserCard
                              onClick={() => handleCardClick(elem.id)}
                              handleEditClick={(e) => handleEditUserClick(e, elem)}
                              show={show === elem.id}
                              elem={elem}
                              key={index}
                              handleChangeUserSwitch={(e) => handleChangeUserSwitch(e, elem)}
                              cardClassName={'blueText'}
                            />
                          )
                        })}
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) :
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  }
                </Container>
              </div>

              {/* Filter Modal */}
              <Modal isOpen={showFilterModal} toggle={() => setShowFilterModal(!showFilterModal)} centered className="filterModal" id="filterModal">
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>Filter</div>
                            <div className="closeButton"><img src={closeImg} alt="close" onClick={() => setShowFilterModal(!showFilterModal)} /></div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleApplyFilter}>
                            <FormGroup >
                              <Label className="common-input-label">
                                Role
                              </Label>
                              <SingleSelect
                                // disabled={editId}
                                id="roleType"
                                // required={true}
                                name="roleType"
                                value={roleVal === null || roleVal === 'undefined' ? '' : roleVal}
                                onChange={(e) => handleChangeRole(e)}
                                options={roleOptions}
                                label={'label'}
                                selectedValueKey={'value'}
                              />
                            </FormGroup>
                            <FormGroup >
                              <Label className="common-input-label">
                                User Status
                              </Label>
                              <SingleSelect
                                // disabled={editId}
                                id="userStatus"
                                // required={true}
                                name="userStatus"
                                defaultOptLabel="All"
                                value={statusVal === null || statusVal === 'undefined' ? '' : statusVal}
                                onChange={(e) => handleChangeUserStatus(e)}
                                options={userStatusOpt}
                                label={'label'}
                                selectedValueKey={'value'}
                              />
                            </FormGroup>
                            <div className='btnGroup'>
                              <CommonButton name='Reset' onClick={handleResetFilter} btnClass={'btnSecondary'} type="button" />
                              <CommonButton name='Apply' btnClass={'btnPrimary'} type="submit" />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>

              {/* Add User Modal */}
              <Modal isOpen={userModal} toggle={() => setUserModal(!userModal)} centered className="userModal" id="userModal">
                {isModalLoading && <CustomSpinner />}
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container fluid>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>{editId ? 'Edit User' : 'Add User'}</div>
                            <div className="closeButton"><img src={closeImg} alt="close" onClick={() => setUserModal(!userModal)} /></div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleUserSubmit}>
                            <Row>
                              <Col lg={3}>
                                <FormGroup>
                                  <Label for="userName">Name <span className='required'>*</span></Label>
                                  <UserInput
                                    required={true}
                                    type='text'
                                    name='userName'
                                    id='userName'
                                    placeholder='Type Here'
                                    // value="vibha"
                                    onChange={(e) => handleChangeUser(e, 'userName')}
                                    value={userDetail.userName === null || userDetail.userName === 'undefined' ? '' : userDetail.userName}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup>
                                  <Label for="userRole">Role <span className='required'>*</span></Label>
                                  <SingleSelect
                                    disabled={editId ? true : false}
                                    id="userRole"
                                    name='userRole'
                                    value={userDetail.userRole === null || userDetail.userRole === 'undefined' ? '' : userDetail.userRole}
                                    onChange={(e) => handleChangeUser(e, 'userRole')}
                                    options={roleOptions && roleOptions.length > 0 ? roleOptions.filter(e => e.value !== Roles.BH_ID) : []}
                                    label={'label'}
                                    required={true}
                                    selectedValueKey={'value'}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup>
                                  <Label for="userDesignation">Designation <span className='required'>*</span></Label>
                                  <SingleSelect
                                    // disabled={editId}
                                    id="userDesignation"
                                    required={true}
                                    name="userDesignation"
                                    value={userDetail.userDesignation === null || userDetail.userDesignation === 'undefined' ? '' : userDetail.userDesignation}
                                    onChange={(e) => handleChangeUser(e, 'userDesignation')}
                                    options={designationOpt}
                                    label={'label'}
                                    selectedValueKey={'value'}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup>
                                  <Label for="userName">Mobile Number <span className='required'>*</span></Label>
                                  <div className='d-flex'>
                                    <UserInput
                                      disabled
                                      type='text'
                                      value="+91"
                                      style={{ maxWidth: '45px', marginRight: '5px' }}
                                    />
                                    <UserInput
                                      required={true}
                                      type='text'
                                      name='userMobile'
                                      id='userMobile'
                                      placeholder='Type Here'
                                      maxLength={10}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      value={userDetail.userMobile === null || userDetail.userMobile === 'undefined' ? '' : userDetail.userMobile}
                                      onChange={(e) => handleChangeUser(e, 'userMobile')}
                                      style={{ flex: 1 }}
                                    />
                                  </div>
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup>
                                  <Label for="userName">Email <span className='required'>*</span></Label>
                                  <UserInput
                                    required={true}
                                    type='email'
                                    name='userEmail'
                                    id='userEmail'
                                    placeholder='Type Here'
                                    value={userDetail.userEmail === null || userDetail.userEmail === 'undefined' ? '' : userDetail.userEmail}
                                    onChange={(e) => handleChangeUser(e, 'userEmail')}
                                  />
                                </FormGroup>
                              </Col>
                              {(+userDetail.userRole === Roles.TM_ID) ? (
                                <Col lg={3}>
                                  <FormGroup>
                                    <Label for="userManagerSh" className='d-flex align-items-center'>Select Manager<span className='required ml-1 mr-2'>*</span>

                                      {/* Role TM, SH or NH List select Radio Group */}
                                      <div className='statusWrapper'>
                                        <FormGroup className='mb-0 radioBlock'>
                                          <div className='d-flex'>
                                            {/* SH */}
                                            <FormGroup className='d-flex align-items-center radioGroup mr-3 mb-0'>
                                              <Input
                                                type='radio'
                                                name='tmManagerRole'
                                                checked={+userDetail.tmManagerRole === Roles.SH_ID}
                                                value={7}
                                                onChange={(e) => handleChangeUser(e, 'tmManagerRole')}
                                                className="m-0"
                                                required
                                              />
                                              <Label className='ml-4 mb-0'>SH</Label>
                                            </FormGroup>
                                            {/* NH */}
                                            <FormGroup className='d-flex align-items-center radioGroup mr-3 mb-0'>
                                              <Input
                                                type='radio'
                                                name='tmManagerRole'
                                                checked={+userDetail.tmManagerRole === Roles.NH_ID}
                                                onChange={(e) => handleChangeUser(e, 'tmManagerRole')}
                                                value={8}
                                                className="m-0"
                                              />
                                              <Label className='ml-4 mb-0'>NH</Label>
                                            </FormGroup>
                                          </div>
                                        </FormGroup>
                                      </div>
                                    </Label>
                                    <SingleSelect
                                      // disabled={editId}
                                      className="mb-0"
                                      id="userManagerSh"
                                      required={true}
                                      name="userManagerSh"
                                      value={userDetail.userManagerSh === null || userDetail.userManagerSh === 'undefined' ? '' : userDetail.userManagerSh}
                                      onChange={(e) => handleChangeUser(e, 'userManagerSh')}
                                      options={+userDetail.tmManagerRole === Roles.NH_ID ? nhList : shList}
                                      label={'first_name'}
                                      labelSecond={'last_name'}
                                      selectedValueKey={'id'}
                                    />
                                  </FormGroup>
                                </Col>
                              ) : ''}
                              {(+userDetail.userRole === Roles.SH_ID) ? (
                                <Col lg={3}>
                                  <FormGroup>
                                    <Label for="userManagerNh">National Head (Select Manager) <span className='required'>*</span></Label>
                                    <SingleSelect
                                      // disabled={editId}
                                      id="userManagerNh"
                                      required={true}
                                      name="userManagerNh"
                                      value={userDetail.userManagerNh === null || userDetail.userManagerNh === 'undefined' ? '' : userDetail.userManagerNh}
                                      onChange={(e) => handleChangeUser(e, 'userManagerNh')}
                                      options={nhList}
                                      label={'first_name'}
                                      labelSecond={'last_name'}
                                      selectedValueKey={'id'}
                                    />
                                  </FormGroup>
                                </Col>
                              ) : ''}

                              {(+userDetail.userRole === Roles.NH_ID) ? (
                                <Col lg={3}>
                                  <FormGroup>
                                    <Label for="userManagerBh">Business Head (Select Manager) <span className='required'>*</span></Label>
                                    <SingleSelect
                                      // disabled={editId}
                                      id="userManagerBh"
                                      required={true}
                                      name="userManagerBh"
                                      value={userDetail.userManagerBh === null || userDetail.userManagerBh === 'undefined' ? '' : userDetail.userManagerBh}
                                      onChange={(e) => handleChangeUser(e, 'userManagerBh')}
                                      options={bhList}
                                      label={'first_name'}
                                      labelSecond={'last_name'}
                                      selectedValueKey={'id'}
                                    />
                                  </FormGroup>
                                </Col>
                              ) : ''}
                              {+userDetail.userRole === Roles.TM_ID ?
                                <Col lg={6}>
                                  <Row>
                                    <Col lg={6}>
                                      <FormGroup className='territorylistBlock'>
                                        <Label for="userTerritory">Territory <span className='required'>*</span></Label>
                                        <div>
                                          <MultiSelectOpt
                                            name="userTerritory"
                                            options={territoryList}
                                            value={selectedTerritory || []}
                                            onChange={(data) => handleChangeTerritory(data)}
                                            labelledBy="userTerritory"
                                            hasSelectAll={false}
                                            disabled={editId ? true : false}
                                          />
                                        </div>
                                        {(errorMsg.territoryError) ? <ErrorBlock title={errorMsg.territoryError} /> : ''}
                                      </FormGroup>
                                    </Col>
                                    {/* <Col lg={12}>
                                      <div className='commonNote redNote'>Note: All selected territory dealers will be automatic assigned to this user.</div>
                                    </Col> */}
                                  </Row>
                                </Col>
                                : ''}
                              {(+userDetail.userRole === Roles.SH_ID || +userDetail.userRole === Roles.NH_ID) ?
                                <Col lg={3}>
                                  <FormGroup>
                                    <Label for="userTerritory">State <span className='required'>*</span></Label>
                                    <div>
                                      <MultiSelectOpt
                                        name="selectedState"
                                        options={stateList}
                                        value={selectedState}
                                        onChange={(data) => handleChangeState(data)}
                                        labelledBy="selectedState"
                                        hasSelectAll={false}
                                      />
                                    </div>
                                    {(errorMsg.stateErr) ? <ErrorBlock title={errorMsg.stateErr} /> : ''}
                                  </FormGroup>
                                </Col>
                                : ''}
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <div className='btnGroup text-center'>
                                  <CommonButton name={editId ? 'Update' : 'Add'} btnClass={'btnPrimary'} type="submit" />
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default ManageUser;